import React from 'react';

import OrderStatusesTable from '../../../components/tables/OrderStatusesTable';
import { useIntl } from 'react-intl';
import SettingsTabulator from '../../../components/layouts/SettingsTabulator';
import OrderStatusToPaymentRuleTable from '../../../components/tables/OrderStatusToPaymentRuleTable';

const OrderStatuses = () =>
{
    const intl = useIntl();
    const translations = intl.messages.orderStatuses;

    const refreshTabComponent = tabulatorId =>
    {
        switch (tabulatorId)
        {
            case "ordersStatusesTab-basic":
                return <OrderStatusesTable />;
            case "ordersStatusesTab-paymentMapping":
                return <OrderStatusToPaymentRuleTable />;
            default:
                return null;
        }
    };

    return (
        <SettingsTabulator
            tabulatorHeader={{
                label: translations.title,
                iconClassName: "fa fa-align-justify"
            }}
            refreshTabComponent={refreshTabComponent}
            tabs={[
                {
                    id: "ordersStatusesTab-basic",
                    header:  {
                        label: translations.tabs.basic,
                        iconClassName: "fa fa-tag"
                    }
                },
                {
                    id: "ordersStatusesTab-paymentMapping",
                    header:  {
                        label: translations.tabs.payment,
                        iconClassName: "fa fa-credit-card"
                    }
                },
            ]}
        />
    );
};

export default OrderStatuses;